import { render } from "./FloatingWindowInput.vue?vue&type=template&id=63ae8f94&scoped=true"
import script from "./FloatingWindowInput.vue?vue&type=script&lang=js"
export * from "./FloatingWindowInput.vue?vue&type=script&lang=js"

import "./FloatingWindowInput.vue?vue&type=style&index=0&id=63ae8f94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-63ae8f94"

export default script